export default "__VITE_PUBLIC_ASSET__81efaa59__"